import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue')
  },
  {
    path: '/datahistory',
    name: 'DataHistory',
    component: () => import('../views/DataHistory.vue')
  },
  {
    path: '/maintenhistory',
    name: 'MaintenHistory',
    component: () => import('../views/MaintenHistory.vue')
  },
  {
    path: '/maintenhistory/:id',
    name: 'MaintenHistoryDetail',
    component: () => import('../views/MaintenHistoryDetail.vue')
  }, 
  {
    path: '/kpi',
    name: 'KPI',
    component: () => import('../views/KPI.vue')
  },
  {
    path: '/errorreport',
    name: 'ErrorReport',
    component: () => import('../views/ErrorReport.vue')
  },
  {
    path: '/errorhistory',
    name: 'ErrorHistory',
    component: () => import('../views/ErrorHistory.vue')
  },
  {
    path: '/errorcodes',
    name: 'ErrorCodes',
    component: () => import('../views/ErrorCodes.vue')
  },
  {
    path: '/manual',
    name: 'Manual',
    component: () => import('../views/Manual.vue')
  },
  {
    path: '/contect',
    name: 'Contect',
    component: () => import('../views/Contect.vue')
  },
  {
    path: '/costanalysis',
    name: 'CostAnalysis',
    component: () => import('../views/CostAnalysis.vue')
  },
  {
    path: '/accounts',
    name: 'Accounts',
    component: () => import('../views/Accounts.vue')
  },
  {
    path: '/maintennotify',
    name: 'MaintenNotify',
    component: () => import('../views/MaintenNotify.vue')
  },
]

const router = new VueRouter({
  routes
})

export default router
